import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../utils/api";
import DataTable from "../components/DataTable";
import { useAuth } from "../contexts/AuthContext";

const UserDashboard = () => {
  const [investments, setInvestments] = useState([]);
  const [userData, setUserData] = useState({});
  const { user } = useAuth();

  const [collapsed, setCollapsed] = useState({
    completed: true,
  });

  useEffect(() => {
    const fetchInvestments = async () => {
      try {
        const res = await api.get("/user/investments");
        setInvestments(res.data.data.investments);
        setUserData(res.data.data.userData);
      } catch (err) {
        console.error(err);
      }
    };
    fetchInvestments();
  }, []);

  const columns = [
    { key: "fdNumber", header: "FD Number" },
    {
      key: "amount",
      header: "Amount",
      render: (row) => `₹${row.amount.toLocaleString("en-IN")}`,
    },
    {
      key: "interestRate",
      header: "Interest Rate",
      render: (row) => `${row.interestRate}%`,
    },
    { key: "duration", header: "Duration (Months)" },
    {
      key: "actions",
      header: "Actions",
      render: (row) => (
        <Link
          to={`/investments/${row.fdNumber}`}
          className="btn btn-outline btn-sm"
        >
          View Details
        </Link>
      ),
    },
  ];

  const grouped = {
    active: [],
    completed: [],
  };

  investments.forEach((inv) => {
    if (inv.status === "active" || inv.status === "completed") {
      grouped[inv.status].push(inv);
    }
  });

  const renderCollapsibleSection = (label, data, key) => {
    if (data.length === 0) return null;
    const isCollapsed = collapsed[key];
    return (
      <div className="mb-4" key={key}>
        <button
          className="btn btn-outline-primary btn-sm d-flex align-items-center"
          onClick={() => setCollapsed({ ...collapsed, [key]: !isCollapsed })}
        >
          <span className="me-1">{label} Investments</span>
          <span
            style={{
              display: "inline-block",
              transition: "transform 0.4s ease",
              transform: isCollapsed ? "rotate(0deg)" : "rotate(90deg)",
            }}
          >
            ▶
          </span>
        </button>
        {!isCollapsed && (
          <div className="mt-2">
            <DataTable
              columns={columns}
              data={data}
              emptyMessage="No investments found"
            />
          </div>
        )}
      </div>
    );
  };

  const renderSection = (label, data) =>
    data.length > 0 && (
      <div className="mb-4">
        <span className="mb-3 btn btn-outline-primary btn-sm">
          {label} Investments
        </span>
        <DataTable
          columns={columns}
          data={data}
          emptyMessage="No investments found"
        />
      </div>
    );

  return (
    <div className="card main-content">
      <div className="flex items-center gap-2 justify-between flex-wrap mb-4">
        <div className="flex items-center gap-3 mb-4">
          <img
            src={
              userData?.userProfilePicture
                ? userData.userProfilePicture
                : "/default.png"
            }
            alt="Profile"
            className="profile-pic"
          />
          <h3 className="mb-0">Welcome, {userData.userName}</h3>
        </div>
        <Link to={`/apply`} className="btn btn-success btn-sm">
          Add New Investment
        </Link>
      </div>
      {renderSection("Active", grouped.active)}
      {renderCollapsibleSection("Completed", grouped.completed, "completed")}
    </div>
  );
};

export default UserDashboard;
